var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPackageEconomy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 20H1.326A1.328 1.328 0 010 18.674V6.5A.5.5 0 01.5 6h19a.5.5 0 01.5.5v4a.5.5 0 01-1 0V7H1v11.674c0 .18.146.326.326.326H16.5a.5.5 0 010 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7a.498.498 0 01-.438-.259l-3.02-5.482A.497.497 0 0015.605 1H4.395a.5.5 0 00-.438.259L.937 6.741a.5.5 0 11-.875-.482L3.082.777C3.345.297 3.849 0 4.395 0h11.21c.546 0 1.05.297 1.313.776l3.02 5.482A.5.5 0 0119.5 7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7a.5.5 0 01-.5-.5v-6a.5.5 0 011 0v6a.5.5 0 01-.5.5zM20.75 22H17.5a.5.5 0 010-1h3.25c.689 0 1.25-.561 1.25-1.25s-.561-1.25-1.25-1.25h-1.5c-1.241 0-2.25-1.009-2.25-2.25S18.009 14 19.25 14h3.25a.5.5 0 010 1h-3.25c-.689 0-1.25.561-1.25 1.25s.561 1.25 1.25 1.25h1.5c1.241 0 2.25 1.009 2.25 2.25S21.991 22 20.75 22z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.012 24a.5.5 0 01-.5-.5v-1.793a.5.5 0 011 0V23.5a.5.5 0 01-.5.5zM20.012 15a.5.5 0 01-.5-.5v-2a.5.5 0 011 0v2a.5.5 0 01-.5.5z"
  })));
}

export default SvgPackageEconomy;